module.exports = __webpack_public_path__ + "static/media/display-suite-16.484d5221.jpg";